import React, { FC, useEffect, useState } from 'react';
import { CustomerApi } from '../API/sdk';
import Icons from '../Components/Icons/icons';

export const LegacySelfcareRedirectTrigger = () => {
	const [state, setState] = useState({
		url: null as any,
		xml: null as any,
		isReadyToSubmit: false
	});

	useEffect(() => {
		// get credentials for legacy login from api
		CustomerApi.signInToLegacyApplication().then(
			(result) => {
				setState({
					url: result.data.url,
					xml: result.data.xml,
					isReadyToSubmit: true
				});
			},
			(fail) => console.error(fail)
		);
	}, []);

	return (
		<div>
			Odota... {Icons.spinner}
			{/* Once credentials have been recieved draw autosubmit form to trigger redirect */}
			{state.isReadyToSubmit ? <SelfSubmittingForm url={state.url} value={state.xml} /> : null}
		</div>
	);
};

const SelfSubmittingForm: FC<{ url: string; value: string }> = (props) => {
	const formRef = React.useRef(null as null | HTMLFormElement);

	useEffect(() => {
		formRef.current?.submit();
	}, []);

	return (
		<div>
			<form action={props.url} ref={formRef}>
				<input name="data" value={props.value} type="hidden" hidden />
			</form>
		</div>
	);
};
